import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import alphabetData from '../Data/alphabetData';
import { shuffle } from '../utils/shuffle';
import { getRandomMascotQuote } from '../utils/mascotQuotes';
import useAudio from '../hooks/useAudio';
import MascotCelebration from './MascotCelebration';
import ScoreBadge from './ScoreBadge';

function QuickQuiz({ onClose }) {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [mascotQuote, setMascotQuote] = useState('');
  const { play } = useAudio();

  useEffect(() => {
    const eligibleWords = [];

    alphabetData.forEach(item => {
      item.words.forEach(word => {
        if (word.games && word.games.includes("QuickQuiz")) {
          eligibleWords.push({ ...word, letter: item.letter });
        }
      });
    });

    const selected = shuffle(eligibleWords).slice(0, 6).map((word) => {
      const wrongOptions = shuffle(
        eligibleWords.filter(w => w.word !== word.word)
      ).slice(0, 2);

      const options = shuffle([word, ...wrongOptions]);

      return {
        image: word.imageFile,
        correct: word.word,
        soundFile: word.soundFile,
        options: options.map(opt => ({ word: opt.word, sound: opt.soundFile }))
      };
    });

    setQuestions(selected);
  }, []);

  const handleAnswer = (word) => {
    if (!questions[current] || selected !== null || showResult) return;

    const correct = questions[current].correct;
    setSelected(word);
    setIsCorrect(word === correct);

    const clickedOption = questions[current].options.find(o => o.word === word);

    if (clickedOption?.sound) {
      play(clickedOption.sound);
    }

    if (word === correct) {
      play('correct.mp3', { interrupt: false });
      setScore(prev => prev + 1);
      setTimeout(() => {
        setSelected(null);
        setIsCorrect(null);
        nextQuestion();
      }, 800);
    } else {
      play('wrong.mp3', { interrupt: false });
      setTimeout(() => {
        setSelected(null);
        setIsCorrect(null);
      }, 800);
    }
  };

  const nextQuestion = () => {
    if (current + 1 < questions.length) {
      setCurrent(prev => prev + 1);
    } else {
      triggerCelebration();
    }
  };

  const playMainSound = () => {
    play(questions[current].soundFile);
  };

  const triggerCelebration = () => {
    setShowConfetti(true);
    setMascotQuote(getRandomMascotQuote());
    setShowResult(true);
    play('fanfare.mp3', { interrupt: false });
  };

  const restartGame = () => {
    window.location.reload();
  };

  if (!questions.length) return <div className="popup"><p>Loading...</p></div>;

  return (
    <div className="popup">
      {showConfetti && <Confetti />}
      <ScoreBadge score={score} />
      <div
        className="quiz-content"
        style={{ opacity: showResult ? 0.35 : 1, pointerEvents: showResult ? 'none' : 'auto', transition: 'opacity 0.3s' }}
      >
        <div className="quiz-round-badge">سوال {current + 1} / {questions.length}</div>
        <img
          src={`${process.env.PUBLIC_URL}/images/${questions[current].image}`}
          alt="quiz-img"
          className="quiz-image"
          onClick={playMainSound}
        />
        <div className="quiz-options">
          {questions[current].options.map((opt, idx) => (
            <button
              key={idx}
              onClick={() => handleAnswer(opt.word)}
              className={`quiz-option ${
                selected === opt.word
                  ? isCorrect
                    ? 'correct-answer'
                    : 'wrong-answer'
                  : ''
              }`}
            >
              {opt.word}
            </button>
          ))}
        </div>
      </div>

      {showResult && (
        <MascotCelebration
          quote={mascotQuote}
          onReplay={restartGame}
          title={`آپ کے درست جوابات: ${score} / ${questions.length}`}
        />
      )}

      <style>{`
        .quiz-content {
          text-align: center;
        }
        .quiz-image {
          width: 45vw;
          height: auto;
          border-radius: 10px;
          margin: 10px auto;
          cursor: pointer;
          box-shadow: 0 0 10px #ccc;
        }
        .quiz-options {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 15px;
        }
        .quiz-option {
          background-color: #fff;
          border: 2px solid #007bff;
          padding: 10px 20px;
          margin: 10px;
          border-radius: 12px;
          font-size: 24px;
          font-family: 'Jameel Noori Nastaleeq', serif;
          cursor: pointer;
          transition: background-color 0.3s, transform 0.2s;
        }
        .quiz-option:hover {
          transform: scale(1.05);
        }
        .correct-answer {
          border-color: green !important;
          transition: 0.3s;
        }
        .wrong-answer {
          border-color: red !important;
          animation: shake 0.3s ease-in-out;
        }
        @keyframes shake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}

export default QuickQuiz;
